<div class="page-title animatedBackground">
    <div class="container">
        <h3>Our Solutions</h3>
        <ul>
            <li><a routerLink="/">Home</a></li>
            <li class="dot-divider"></li>
            <li>Our Solutions</li>
        </ul>
    </div>
    <div class="bg-pattern"><img src="assets/img/bg-pattern-2.png" alt="pattern"></div>
</div>

<section class="services-area ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-services">
                    <div class="icon">
                        <i class="icofont-automation"></i>
                    </div>
                    <h3>Odoo</h3>
                    <p>The only platform you will ever need to help run your business: integrated apps, kept simple, and loved by millions of happy users.</p>
                    <a routerLink="/odoo-solution" class="read-more-btn">Read More</a>
                </div>
            </div>
            
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-services">
                    <div class="icon">
                        <i class="icofont-computer"></i>
                    </div>
                    <h3>Openbravo</h3>
                    <p>Manage all your retail channels from one single point, and so gain unified, real-time visibility into your unified commerce operations.</p>
                    <a routerLink="/openbravo-solution" class="read-more-btn">Read More</a>
                </div>
            </div>
            
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-services">
                    <div class="icon">
                        <i class="icofont-people"></i>
                    </div>
                    <h3>HR Management System</h3>
                    <p>Natively built on odoo framework,OSIT HRMS is a complete solution connecting every human resource process from hire to retire.</p>
                    <a routerLink="/hr-solution" class="read-more-btn">Read More</a>
                </div>
            </div>
            
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-services">
                    <div class="icon">
                        <i class="icofont-bar-code"></i>
                    </div>
                    <h3>Point of Sale (POS)</h3>
                    <p>A fully-featured, mobile-enabled POS solution that can be deployed on any type of device to deliver excellent customer service. </p>
                    <a routerLink="/pos-solution" class="read-more-btn">Read More</a>
                </div>
            </div>
            
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-services">
                    <div class="icon">
                        <i class="icofont-stethoscope-alt"></i>
                    </div>
                    <h3>Hospital Management System</h3>
                    <p>eHospital Systems is a hospital management system software designed to manage all aspects of a hospital operation. </p>
                    <a routerLink="/hospital-solution" class="read-more-btn">Read More</a>
                </div>
            </div>
            
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-services">
                    <div class="icon">
                        <i class="icofont-vehicle-delivery-van"></i>
                    </div>
                    <h3>Logistics Management System</h3>
                    <p>A logistics management system is a combination of software tools that optimize business processes from beginning to end. </p>
                    <a routerLink="/logistics-solution" class="read-more-btn">Read More</a>
                </div>
            </div>
        </div>
    </div>
</section>

